export default __webpack_public_path__ + "static/media/bs.27d37692.svg";